<template>
    <div id='food' class='d-flex flex-column' style='height: 100%'>
        
        <div class='container'>
            <h3> <fa-icon icon="chevron-left" @click="showPreviousPage" /> {{ title }} </h3>
            <div v-if="!done" style="max-width: 700px">
                <Textfield ref="textfield" @enter="enter" :placeholder="placeholder" @input="typing" />
                <ul class='text-suggestions'>
                    <li href='javascript: ' v-for="word in autocomplete" :key="word.id" @click="quickSuggestionPicked(word.text)">
                        <a href='javascript: '>{{word.text}}</a>
                    </li>
                </ul>
                <a @click="skip" v-if="tags.length < 1 && autocomplete.length < 1" style='float: right; cursor: pointer'>Skip</a>
            </div>
            <Tag v-for="text in tags" :text="text" :key="text" @remove-tag="removeTag" />
        </div>
        <div style='flex-grow: 2' />

        <div v-if="done" class='container d-flex align-items-center'>
            <img src="/icons/down.png" @click="submit">
            <p>{{ nextHint }}</p>
        </div>
        <div v-else>
            <div class='container'>
                <p>A few examples</p>
            </div>
            
            <div style=''>
                <PickerOption 
                    v-for="word in words"
                    :key="word.id"
                    :text="word.text" 
                    image="https://craftlog.com/m/i/3094087=s1280=h960" 
                    v-on:option-picked="optionPicked" />
            </div>
        </div>        
    </div>
</template>

<script>

import Page from "../widgets/PageBack"
import Tag from "../widgets/Tag";
import PickerOption from "../widgets/PickerOption";
import Textfield from  "../widgets/Textfield"
import http from "../../lib/http.ts"

export default {
    name: 'food',
    components: {Tag, PickerOption, Textfield},

    props: {
        title: {type: String, required: true},
        'next-page': {type: String, required: true},
        previousPage: {type: String, required: true},
        'next-hint': {type: String, required: true},
        placeholderText: {type: String, required: true},
        poll: {required: true},
        pollType: {type: String, required: true},
        location: {required: true}
    },

    data() {
        return {
            tags: [], 
            words: [],
            autocomplete: []
        }
    },

    mounted() {
        this.words = this.poll.words.slice(0, (this.small ? 8 : 20))
    },

    computed: {
        placeholder() {
            let suffix = this.tags.length == 0 ? "Let us know 3" : `Pick ${3 - this.tags.length} more`
            return `${this.placeholderText}... (${suffix})`
        },

        done(){
            return this.tags.length >= 3;
        },

        small(){
            return window.innerWidth < 800;
        }
    },

    methods: {
        enter(el){
            let value = el.value;
            if(! value) 
                return;
            this.addTag(value);
            this.$ga.event('Vote', 'Typed', value);
            el.value = "";
        },

        typing(el){
            if(! el.value){
                this.autocomplete = [];
                return;
            }
            this.autocomplete = this.poll.words.filter( w => w.text.toLowerCase().includes(el.value.toLowerCase()));
        },

        quickSuggestionPicked(text){
            this.addTag(text);
            this.$refs.textfield.clear();
            this.autocomplete = [];
            this.$ga.event('Vote', 'Quick Suggestion Pick', text);
        },

        addTag(text) {
            if(! this.tags.includes(text))
                this.tags.push(text);
        },

        removeTag(text){
            this.tags = this.tags.filter(value => (value != text));
        },

        optionPicked(text) {
            this.addTag(text);
            this.$ga.event('Vote', 'Suggestion Pick', text);
        },

        submit(){
            http().post(`/polls/${this.poll.id}/submit`, {answers: this.tags});
            this.$ga.event('Vote', 'Submit', `${this.pollType}: ${this.tags.join(", ")}`);
            this.showNextPage();
        },

        skip(){
            this.$ga.event('Vote', 'Skip', `${this.location.name}: ${this.pollType}`, this.poll.id);
            this.showNextPage();
        },

        showNextPage(){
            this.$emit('show-page', this.nextPage);
        },

        showPreviousPage(){
            this.$ga.event('Button', 'Click', `Back: ${this.pollType}`)
            this.$emit('show-page', this.previousPage);
        }

    }
}
</script>

<style lang="scss" scoped>
    #food {padding-top: 40px; overflow: auto;}
    h3 {margin-bottom: 20px}
    .textfield {margin-bottom: 20px}
    IMG {height: 80px; margin-bottom: 20px; cursor: pointer; margin-right: 20px}
    UL.text-suggestions {
        margin-left: -40px;
        li {
            display: inline;
            &:after {
                content: ", "
            }
            &:last-child {
                &:after {content: ""}    
            }
        }
    }


    @media (max-width: 767.98px) { 
        #food {padding-top: 20px}
        IMG {height: 60px}
    }
</style>